import { PAGE_NAME } from "../enum/page-name";
import { REPORT_STATUS } from "../enum/report-status";

export function mapPageNameToString(pageName: PAGE_NAME): string {
    switch (pageName) {
        case PAGE_NAME.PROFILE:
            return "Profil";
        case PAGE_NAME.MESSENGER:
            return "Chat";
        case PAGE_NAME.ACTIVITY:
            return "Activité";
        case PAGE_NAME.BOOKING:
            return "Réservation";
        case PAGE_NAME.OUTING:
            return "Sortie";
    }
}

export function mapReportStatusToString(status: REPORT_STATUS): string {
    switch (status) {
        case REPORT_STATUS.PENDING:
            return "En attente";
        case REPORT_STATUS.IN_PROGRESS:
            return "En cours";
        case REPORT_STATUS.RESOLVED:
            return "Résolu";
        case REPORT_STATUS.REJECTED:
            return "Rejeté";
    }
}

type TagSeverity = "success" | "secondary" | "info" | "warn" | "danger" | "contrast" | null | undefined;
export function mapReportStatusToSeverity(status: REPORT_STATUS): TagSeverity  {
    switch (status) {
        case REPORT_STATUS.PENDING:
            return "warn";
        case REPORT_STATUS.IN_PROGRESS:
            return "info";
        case REPORT_STATUS.RESOLVED:
            return "success";
        case REPORT_STATUS.REJECTED:
            return "danger";
    }
}